// extracted by mini-css-extract-plugin
export default {"ToCallContainer":"toCall_ToCallContainer__hQ8t4"};